module.exports = "../dist/img/mini-29.06e8.jpg";